import { render } from "./ProductInventory.vue?vue&type=template&id=0dbc5eaa&scoped=true"
import script from "./ProductInventory.vue?vue&type=script&lang=js"
export * from "./ProductInventory.vue?vue&type=script&lang=js"

import "./ProductInventory.vue?vue&type=style&index=0&id=0dbc5eaa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbc5eaa"]])

export default __exports__